import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

const { app } = window;

function addFm(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	// [fm]
	vuw.add("fm", {
		vuwType: "jbForm",
		app,
		inputIdPrefix: "edit",
		enableAddExecModeParam: false,	// modeパラメータを付与しない
		autoInit: false,
		scrollBuffer: vuwer.get("body").smoothScrollBuffer || 30,
		
		selector() {
			return $("<form/>").addClass("fm fm-edit").attr("id", "fm_edit")
			.appendTo(this.container.$content);
		},
		
		onReady($self) {
			// add event listener
			$self
			.on(
				"changeSheet.scrollToTopOnNextSheet",
				(e, currentSheet, nextSheet) => this.scrollToTopOnNextSheet(currentSheet, nextSheet)
			);
		},
		
		async scrollToTopOnNextSheet(currentSheet, nextSheet) {
			// スクロール位置を上部へ
			const smoothScrollBuffer = vuwer.get("body").smoothScrollBuffer;
			const scrollBuffer = u_.isNumber(smoothScrollBuffer) ? smoothScrollBuffer : 0;
			
			if(currentSheet) {
				// クエリデータの更新
				if(this.getSheet().indexOf(nextSheet) === 0) {
					delete app._GET.sheet;
				} else {
					app._GET.sheet = nextSheet.name;
				}
				app.replaceState(app._GET);
			}
			
			await new Promise(resolve => setTimeout(() => {
				const marginTop = parseInt( this.$self.css("margin-top") );
				const scrollTop = this.$self.offset().top - marginTop - scrollBuffer;
				if(vuwer.$window.scrollTop() > scrollTop) {
					$(document.scrollingElement).animate({ scrollTop }, {
						duration: "fast",
						complete: resolve
					});
				} else {
					resolve();
				}
			}, 0));
		},
		
		async refresh() {
			if( !u_.isObject(app.module.config.form) ) {
				return false;
			}
			
			this.removeChildren().$self.empty();
			
			this.state = {};
			this.config = {};
			this._lastVal = undefined;
			
			const { ajaxTimeoutTime } = app.config;
			
			this.setDataId("").resetMembers().setConfig({
				...app.module.config,
				ajaxTimeoutTime
			});
			
			// re init
			await this.initForm();
			
			const dataKey = app.module.getDataKey();
			
			// this._refreshForWysiwyg();
			
			if(dataKey === "users") {
				// lv項目のカスタム
				const fieldLv = this.getField("select").lv;
				
				// override required validation
				fieldLv.addValidation("required", val => {
					if(this.getDataId() === app.config.account.itemId) {
						return true;
					} else {
						return !fieldLv.required || !!val || val === 0;
					}
				}, "選択して下さい");
				
				//override _getCopiedInp
				fieldLv._getCopiedInp = (...args) => {
					if(this.getDataId() === app.config.account.itemId) {
						return [$("<span/>").addClass("replaced-inp").text(app.config.account.lvDisp)];
					} else {
						return Klass(fieldLv.klass).prototype._getCopiedInp.call(fieldLv, ...args);
					}
				};
			}
			
			// コールバックの実行
			if( u_.isFunction(app.editFormInitCallBacks[dataKey]) ) {
				const res = await app.editFormInitCallBacks[dataKey].call(this, this.$self, this);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.editFormInitCallBacks.always) ) {
				const res = await app.editFormInitCallBacks.always.call(this, this.$self, this);
				if(res === false) {
					return res;
				}
			}
			
			return true;
		},
		
/*
		// refresh時のwysiwyg項目用の処理
		_refreshForWysiwyg() {
			const fields = this.getField("wysiwyg");
			Object.keys(fields).forEach(pk => {
				const vuwField = fields[pk];
				if(vuwField.quill && !vuwField.useFrame && vuwField.theme === "snow") {
					vuwField.add("toolbar", {
						selector() {
							return $(this.container.quill.getModule("toolbar").container);
						}
					}, function() {
						// [position tracking]
						vuwer.positionTracker.tracking(this, true, false, () => {
							// calc buffer
							return vuwer.get("siteHeader").$self.outerHeight(true);
						}, (isFixed, buffer) => {
							// change callback
							this.$self.width(isFixed ? this.$self.width() : "").css({
								left: isFixed ? "50%" : "",
								position: isFixed ? "fixed" : "",
								top: isFixed ? buffer : "",
								transform: isFixed ? "translateX(-50%)" : ""
							});
						});
						
						this.getReady();
					});
				}
			});
			return this;
		},
*/
		
		// [override] ajaxリクエスト送信 app.moduleの同関数を利用する
		_sendRequest(method, ajaxSetting, cb) {
			if(app.module) {
				const k = method.replace(/^aRequest|Upload$/g, "").toLowerCase();
				
				// for fileUploader
				const vuwForm = u_.isObject(this.execModeValues) ? this : this.container.getForm();
				
				if( u_.hasProperty(vuwForm.execModeValues, k) ) {
					const arr = [vuwForm.getDataId()];
					
					if(k === "exec") {
						// updateはPUTにする
						!!arr[0] && (ajaxSetting.type = "PUT");
						
					} else {
						// exec以外の場合はendPointとする
						arr.push( vuwForm.execModeValues[k] );
					}
					
					!arr[0] && arr.shift();
					ajaxSetting.endPoint = arr.join("/");
				}
				
				return app.module._sendRequest(method, ajaxSetting, cb);
				
			} else {
				return Klass(this.klass).prototype._sendRequest.apply(this, arguments);
			}
		},
		
		// [フォームの値が更新された後のコールバック]
		async onUpdate(val, config) {
			const dataKey = app.module.getDataKey();
			
			if(dataKey === "users") {
				const isSelf = (val.uid === app.config.account.uid);
				$("#inp_edit_uid").prop("readonly", isSelf);
				$("#inp_edit_lv").prop("disabled", isSelf)
				.next(".inp-sel").children().attr({
					"data-self": isSelf ? app.config.account.lvDisp : null
				});
			}
			
			// コールバックの実行
			if( u_.isFunction(app.editFormUpdateCallBacks[dataKey]) ) {
				const res = await app.editFormUpdateCallBacks[dataKey].apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.editFormUpdateCallBacks.always) ) {
				const res = await app.editFormUpdateCallBacks.always.apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			
			return true;
		},
		
		// [jsValidate実行時のコールバック]
		async onValidate($activeSheet, objError, config) {
			const dataKey = app.module.getDataKey();
			
			// コールバックの実行
			if( u_.isFunction(app.editFormValidateCallBacks[dataKey]) ) {
				const res = await app.editFormValidateCallBacks[dataKey].apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.editFormValidateCallBacks.always) ) {
				const res = app.editFormValidateCallBacks.always.apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			
			return true;
		},
		
		// [確認シートへ値がコピーされる際のコールバック]
		onCopyToConfirmSheet($cloneSheet, config) {
			const dataKey = app.module.getDataKey();
			
			// コールバックの実行
			if( u_.isFunction(app.editFormConfirmCallBacks[dataKey]) ) {
				const res = app.editFormConfirmCallBacks[dataKey].apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.editFormConfirmCallBacks.always) ) {
				const res = app.editFormConfirmCallBacks.always.apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			
			return true;
		},
		
		// submit成功コールバック
		onSubmitSuccess(config, res) {
			const dataKey = app.module.getDataKey();
			
			// コールバックの実行
			if( u_.isFunction(app.editFormSubmitCallBacks[dataKey]) ) {
				const res = app.editFormSubmitCallBacks[dataKey].apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.editFormSubmitCallBacks.always) ) {
				const res = app.editFormSubmitCallBacks.always.apply(this, arguments);
				if(res === false) {
					return res;
				}
			}
			
			return app.initList();
		},
		
		// [override] 子VuwSheet用のデフォルト設定の取得
		getDefaultSheetProp(sheetName) {
			const prop = Klass(this.klass).prototype.getDefaultSheetProp.apply(this, arguments);
			
			if(sheetName === this.finishSheetName) {
				// for "finish"
				prop.btns = {
					more: {
						text: "続けて登録する",
						func: function more() {
							this.getForm().clearVal().setActiveSheet(0);
						}
					}
				};
			}
			
			if( u_.isObject(prop.btns) && prop.btns.reset ) {
				// resetボタンの挙動を変更
				prop.btns.reset.func = function reset() {
					const form = this.getForm();
					if(u_.isObject(form._lastVal) && Object.keys(form._lastVal).length) {
						// _lastValがあれば反映する
						this.setVal(form._lastVal);
						
					} else {
						this.clearVal();
					}
				};
			}
			
			return prop;
		},
		
		// [overrdie] フォームに値を反映
		setVal(val) {
			if(val !== this._lastVal) {
				// セットしたデータを記録（リセットボタン押下時用）
				this._lastVal = val;
				
				if( u_.isObject(val) && u_.hasProperty(val, "itemId") ) {
					// IDが存在する場合はセット
					this.setDataId(val.itemId);
				} else {
					// 無ければクリア
					this.setDataId("");
				}
			}
			
			return Klass(this.klass).prototype.setVal.apply(this, arguments);
		},
		
		// [overrdie] フォームの値をクリア
		clearVal() {
			!!this._lastVal && (delete this._lastVal);
			return Klass(this.klass).prototype.clearVal.apply(this, arguments);
		},
		
		// [original]
		getLastVal() {
			return this._lastVal;
		}
	}, function() {
		// errorCallbacksをapp.moduleへマージ
		Object.keys(this.errorCallbacks).forEach(k => {
			if( !u_.hasProperty(app.module.errorCallbacks, k) ) {
				app.module.errorCallbacks[k] = this.errorCallbacks[k].bind(this);
			}
		});
		
		// appから直接アクセス可能にする
		app.fm.edit = this;
	});
}

export default addFm;
